import { TFunction } from 'react-i18next';
import * as Yup from 'yup';

import { Locker, LockerFormData } from '../../../../../types/api/lockers';

export function getDays(t: TFunction) {
  return [
    { label: t('Monday'), dayOfWeek: 1 },
    { label: t('Tuesday'), dayOfWeek: 2 },
    { label: t('Wednesday'), dayOfWeek: 3 },
    { label: t('Thursday'), dayOfWeek: 4 },
    { label: t('Friday'), dayOfWeek: 5 },
    { label: t('Saturday'), dayOfWeek: 6 },
    { label: t('Sunday'), dayOfWeek: 7 },
  ];
}

export function getInitialValues(data: Locker | undefined) {
  return {
    title: data?.title,
    address: data?.address,
    active: data?.active,
    createdAt: data?.createdAt,
    numBoxes: data?.numBoxes,
    maintenance_windows: data?.maintenanceWindows,
  };
}

export function toApiData(values: LockerFormData) {
  let apiData = {
    ...values,
  };

  apiData.num_boxes = values.numBoxes ? values.numBoxes : 1;

  delete apiData.title;
  delete apiData.address;
  delete apiData.active;
  delete apiData.createdAt;
  delete apiData.numBoxes;

  return apiData;
}

export function getValidationSchema(t: TFunction) {
  return Yup.object().shape({
    title: Yup.string().optional(),
    address: Yup.mixed().optional(),
    active: Yup.number().optional(),
    createdAt: Yup.string().optional(),
    numBoxes: Yup.number().optional(),
    maintenance_windows: Yup.array().of(
      Yup.object().shape({
        start_day_of_week: Yup.number().required(),
        end_day_of_week: Yup.number().required(),
        openingHours: Yup.array()
          .of(
            Yup.object().shape({
              from: Yup.string()
                .required(t('Required'))
                .matches(/^\d{2}:\d{2}$/, t('Must be in HH:MM')),
              to: Yup.string()
                .required(t('Required'))
                .matches(/^\d{2}:\d{2}$/, t('Must be in HH:MM')),
            })
          )

          .test(
            'from-before-to',
            t('Start time must be before end time for each day'),
            function (openingHours) {
              if (!Array.isArray(openingHours)) return true;

              const sorted = [...openingHours].sort((a: any, b) =>
                a.from.localeCompare(b.from)
              );

              for (let i = 0; i < sorted.length; i++) {
                const { from, to }: any = sorted[i];
                const [h1, m1] = from.split(':').map(Number);
                const [h2, m2] = to.split(':').map(Number);

                if (h1 > h2 || (h1 === h2 && m1 > m2)) {
                  return this.createError({
                    message: t(
                      'Start time must be before end time for each day'
                    ),
                  });
                }

                if (i < sorted.length - 1) {
                  const next: any = sorted[i + 1];
                  const [nh1, nm1] = next.from.split(':').map(Number);
                  if (h2 > nh1 || (h2 === nh1 && m2 > nm1)) {
                    return this.createError({
                      message: t(
                        'Start time must be before end time for each day'
                      ),
                    });
                  }
                }
              }

              return true;
            }
          ),
      })
    ),
  });
}
